import Seo from "../components/Seo";
import { KineticLines, SectionLabel } from "../components/Reveal";
import { Link } from "react-router-dom";

const SECTIONS = [
  {
    h: "Overview",
    p: ["Bottom Line Improvements (“we,” “us”), a division of Community Promotions, respects the privacy of every visitor and inquiry. This policy explains what information we collect through this website and how it is used."],
  },
  {
    h: "Information We Collect",
    p: [
      "When you complete the savings opportunity review or an inquiry form, we collect the information you provide: your name, business name, business email, optional phone number, business type and size, the opportunity areas you selected, and any comments you choose to share.",
      "We also collect basic technical information such as the page you submitted from and a general record of the submission, to protect against spam and misuse.",
    ],
  },
  {
    h: "How We Use Information",
    p: [
      "We use the information you provide to review your interests, contact you about your inquiry, and help connect you with independent specialist providers relevant to the areas you selected. We do not sell your personal information.",
      "If you opt in to occasional updates, we may send you new savings opportunities worth knowing about. You can opt out at any time by contacting us.",
    ],
  },
  {
    h: "Sharing With Specialists",
    p: [
      "When you inquire about a specific area, relevant details from your inquiry may be shared with independent specialist providers so they can evaluate your situation and follow up with you. Specialists are responsible for handling your information in connection with the services they provide.",
      "Bottom Line Improvements may receive referral compensation when customers choose services through participating provider relationships.",
    ],
  },
  {
    h: "Data Security & Retention",
    p: [
      "Inquiry data is stored securely in our application backend with access limited to our team. We retain inquiry information only as long as needed to respond to your request and maintain a useful record of our communications, unless a longer period is required by law.",
    ],
  },
  {
    h: "Your Choices",
    p: [
      "You may request access to, correction of, or deletion of the information you submitted by contacting us using the details on our Contact page. You may also decline optional consent checkboxes at any time — only the privacy consent is required to submit an inquiry.",
    ],
  },
  {
    h: "Changes To This Policy",
    p: ["We may update this policy from time to time. The current version will always be posted on this page with its effective date."],
  },
];

export default function Privacy() {
  return (
    <main data-testid="page-privacy">
      <Seo
        title="Privacy Policy"
        description="How Bottom Line Improvements collects, uses, and protects the information you share through the savings opportunity review and inquiry forms."
        path="/privacy"
      />
      <section className="relative overflow-hidden bg-ice pt-28 lg:pt-36 pb-12">
        <div className="absolute inset-0 bg-arch" aria-hidden="true" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionLabel>Legal</SectionLabel>
          <KineticLines as="h1" className="mt-4 font-display font-extrabold tracking-tightest text-navy text-4xl sm:text-5xl" lines={["Privacy Policy"]} />
          <p className="mt-4 text-sm text-slate">Effective date: [to be set at launch] · A division of Community Promotions</p>
        </div>
      </section>
      <section className="py-14 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          {SECTIONS.map((s) => (
            <div key={s.h}>
              <h2 className="font-display font-extrabold tracking-tight text-navy text-xl md:text-2xl">{s.h}</h2>
              {s.p.map((para, i) => (
                <p key={i} className="mt-3 text-[15px] leading-relaxed text-slate">{para}</p>
              ))}
            </div>
          ))}
          <div className="rounded-2xl border border-line bg-ice/50 p-6">
            <p className="text-sm leading-relaxed text-slate">
              Questions about this policy? Email <a href="mailto:admin@communitypromotionsllc.com" className="font-bold text-teal-dark underline">admin@communitypromotionsllc.com</a> or reach us through the{" "}<Link to="/contact" className="font-bold text-teal-dark underline">Contact page</Link>.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
